import axios from "axios";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const axiosApi = axios.create({
  //Base URL for API calls
  baseURL: "https://us-central1-stryi-citizen.cloudfunctions.net/api",
  // baseURL: "http://localhost:5001/stryi-citizen/us-central1/api",
  // withCredentials: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

// Promise that resolves once Firebase auth state is first determined (lazy init)
let _authReady = null;
function waitForAuth() {
  if (!_authReady) {
    _authReady = new Promise((resolve) => {
      const unsubscribe = onAuthStateChanged(getAuth(), () => {
        unsubscribe();
        resolve();
      });
    });
  }
  return _authReady;
}

// Attach Firebase auth token to every request (waits for auth on first load)
axiosApi.interceptors.request.use(async (config) => {
  await waitForAuth();
  const user = getAuth().currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const fileApi = axios.create({
  //Base URL for API calls
  baseURL: "https://stryi-rada.gov.ua/wp-json/myplugin/v1/upload-file",
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});
let api = {
  axiosApi: axiosApi,
  fileApi: fileApi,
};

export default api;
